import React from 'react';
import './MobileHeader.css';

interface MobileHeaderProps {
  onMenuClick: () => void;
  onDocumentClick: () => void;
  onChatClick: () => void;
  onSettingsClick: () => void;
  currentDocument?: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  onMenuClick,
  onDocumentClick,
  onChatClick,
  onSettingsClick,
  currentDocument
}) => {
  return (
    <header className="mobile-header">
      <div className="header-top">
        <button className="menu-btn" onClick={onMenuClick}>
          ☰
        </button>
        <h1 className="app-title">Psagot Global Equity Desk</h1>
        <div className="header-actions">
          <button className="action-btn" onClick={onDocumentClick}>
            📄
          </button>
          <button className="action-btn" onClick={onChatClick}>
            💬
          </button>
          <button className="action-btn" onClick={onSettingsClick}>
            ⚙️
          </button>
        </div>
      </div>
      
      {currentDocument && (
        <div className="document-context">
          <div className="document-info">
            <span className="document-icon">📄</span>
            <span className="document-title">{currentDocument}</span>
          </div>
          <div className="document-actions">
            <button className="context-btn">View PDF</button>
            <button className="context-btn">Full Screen</button>
            <button className="context-btn">×</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default MobileHeader; 